/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1IndividualpaymentParcelsEditMultiple200,
  PutApiV1IndividualpaymentParcelsEditMultiple401,
  PutApiV1IndividualpaymentParcelsEditMultiple500,
  PutApiV1IndividualpaymentParcelsEditMultipleMutationRequest,
  PutApiV1IndividualpaymentParcelsEditMultipleMutationResponse,
} from "../../types/individualPaymentOperationsController/PutApiV1IndividualpaymentParcelsEditMultiple.ts";
import { individualPaymentEditMultipleViewModelSchema } from "../individualPaymentEditMultipleViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1IndividualpaymentParcelsEditMultiple200Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentParcelsEditMultiple200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1IndividualpaymentParcelsEditMultiple401Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentParcelsEditMultiple401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1IndividualpaymentParcelsEditMultiple500Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentParcelsEditMultiple500>;

export const putApiV1IndividualpaymentParcelsEditMultipleMutationRequestSchema =
  z.lazy(
    () => individualPaymentEditMultipleViewModelSchema,
  ) as unknown as ToZod<PutApiV1IndividualpaymentParcelsEditMultipleMutationRequest>;

export const putApiV1IndividualpaymentParcelsEditMultipleMutationResponseSchema =
  z.lazy(
    () => putApiV1IndividualpaymentParcelsEditMultiple200Schema,
  ) as unknown as ToZod<PutApiV1IndividualpaymentParcelsEditMultipleMutationResponse>;
